export const ENV = {
  GQL: {
    // URI: 'http://localhost:3000/graphql'
    URI: 'https://api-install-qa.sodimac-it.com/bff/graphql'
  },
  PWA: {
    PUSH_NOTIFICATIONS: {
      PUBLIC_KEY: 'BP1ixPgjKUdHS9o41xPplYAdL8hdu0eV0IZZC6V7tJ92DSuD8Y3jnpuRidX7EZTSB2mZ5j156RP3RUNkmJ2n3jc'
      // PRIVATE_KEY: '9ztDRBfMTsiE7xsZlKSfA4BBlm0-g0GcWI9e5NCnMVM'
    }
  }
};
